import { LegacyCard, DropZone, Layout, Page, LegacyStack, Text, Thumbnail } from '@shopify/polaris';
import { HorizontalDotsMinor } from '@shopify/polaris-icons';
import { useCallback, useContext, useEffect, useState } from 'react';
import ToastContext from '../../../context/ToastContext';
import { SET_ERROR, SET_OK } from '../../../context/ToastReducer';
import { postFileUpcEPH } from '../../../services/productService';

const UploadProductsFileEPH = () => {
  return (
    <Page
      title="Inventario con fichero EPH"
      divider
      backAction={{
        content: 'Todos los productos',
        url: '/products',
        accessibilityLabel: 'Todos los productos',
      }}
    >
      <FileInputState />
    </Page>
  );
};

const FileInputState = () => {
  const [files, setFiles] = useState([]);
  const [, dispatchToast] = useContext(ToastContext);

  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) => setFiles((f) => [...f, ...acceptedFiles]),
    [],
  );

  const validImageTypes = ['text/plain'];

  const fileUpload = !files.length && <DropZone.FileUpload />;
  const uploadedFiles = files.length > 0 && (
    <LegacyStack vertical>
      {files.map((file, index) => (
        <LegacyStack alignment="center" key={index}>
          <Thumbnail
            size="small"
            alt={file.name}
            source={validImageTypes.includes(file.type) ? window.URL.createObjectURL(file) : HorizontalDotsMinor}
          />
          <div style={{ padding: 10 }}>
            {file.name}{' '}
            <Text variant="headingSm" as="h6">
              {file.size} bytes
            </Text>
          </div>
        </LegacyStack>
      ))}
    </LegacyStack>
  );

  useEffect(() => {
    files.forEach((f) => {
      const form = new FormData();
      form.append('file', f, f.name);

      postFileUpcEPH(form)
        .then((r) => {
          dispatchToast({ type: SET_OK, payload: r.data });
        })
        .catch((e) => {
          dispatchToast({ type: SET_ERROR, payload: e.response.data });
        })
        .finally(() => {
          setFiles([]);
        });
    });
    // eslint-disable-next-line
  }, [files]);

  return (
    <Layout>
      <Layout.Section secondary>
        <Text variant="bodyMd" as="p" color="subdued">
          Añada un fichero con la relación de códigos de EAN de Mirto y UPC de EPH
        </Text>
      </Layout.Section>
      <Layout.Section>
        <LegacyCard sectioned>
          <DropZone onDrop={handleDropZoneDrop}>
            {uploadedFiles}
            {fileUpload}
          </DropZone>
        </LegacyCard>
      </Layout.Section>
    </Layout>
  );
};

export default UploadProductsFileEPH;
